import { AllPermissions as SharedAllPermissions, Permission as SharedPermission } from 'shared-lib'

export const Permission = SharedPermission

export type AllPermissions = SharedAllPermissions
